<template>
  <div class="movie">
    <PpvToast></PpvToast>
    <wavvie-popup v-if="isWavviePopupShow" :close-fn="popupClose"></wavvie-popup>
    <super-multi-section></super-multi-section>
    <div class="ppv-notice">
      <p>Wavvie 영화관은 PLAYY가 제공하는 영화를 포함하고 있습니다.</p>
    </div>
  </div>
</template>
<script>
import SuperMultiSection from '@/components/container/SuperMultiSection'
import { setDisableScrolling, scrollTop, isPrerenderer } from '@/common/utils/common'
import { mapMutations } from 'vuex'
import { MENU, SET_CURRENT_MENU } from '@/common/resources/const'
import WavviePopup from '@/components/common/WavviePopup'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import PpvToast from '@/components/movie/PpvToast'
export default {
  components: {
    SuperMultiSection,
    WavviePopup,
    PpvToast
  },
  data () {
    return {
      isWavviePopupShow: false
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    popupClose () {
      setDisableScrolling(false)
      let expires = new Date()
      expires.setDate(expires.getDate() + 365)
      cookie.setItem('wavvie-popup', '1', expires.toUTCString(), constant.URL_COOKIE_DOMAIN, '/')
      this.isWavviePopupShow = false
    }
  },
  created () {
    scrollTop()
    setDisableScrolling(false)
    this[SET_CURRENT_MENU](MENU.MOVIE)
  },
  mounted () {
    if (!isPrerenderer() && !cookie.isWavveOn() && cookie.getItem('wavvie-popup') !== '1') {
      this.isWavviePopupShow = true
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/movie.scss"></style>
<style scoped>
  .ppv-notice{
    padding: 20px 0;
    margin-top: -40px;
    margin-bottom: 40px;
    font-size: 14px;
    line-height: 20px;
    color: #5e5e5e;
    text-align: center;
  }
</style>
